import _replaceAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/replace-all";
import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicationFieldVisibility } from "@Client/@Composables/application-standalone/useApplicationFieldVisibility";
import { useFillOutVisibility } from "@Client/@Composables/application-standalone/useFillOutVisibility";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { computed } from "@vue/composition-api";
export const useOtherPropertiesFieldVisibility = options => {
  const {
    computeSchemaVisibility,
    computeTogglerVisibility
  } = useApplicationFieldVisibility();
  const {
    computeFillOutVisibility
  } = useFillOutVisibility();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const existingMortgageIndex = computed(() => {
    var _options$existingMort;
    return (_options$existingMort = options.existingMortgageIndex) == null ? void 0 : _options$existingMort.value;
  });
  const otherPropertyPath = computed(() => {
    return currentApplicantPath.value + "[other-properties]" + "[" + options.otherPropertyIndex.value + "]";
  });
  const existingMortgagePath = computed(() => {
    return otherPropertyPath.value + "[other-property-existing-mortgages]" + "[" + existingMortgageIndex.value + "]";
  });
  const otherPropertyVisibilityPath = computed(() => {
    var _context;
    return _replaceAllInstanceProperty(_context = otherPropertyPath.value).call(_context, /\[[[0-9]+\]/g, "");
  });
  const existingMortgageVisibilityPath = computed(() => {
    var _context2;
    return _replaceAllInstanceProperty(_context2 = existingMortgagePath.value).call(_context2, /\[[[0-9]+\]/g, "");
  });
  const isApplicantVisibleFromFillOut = computed(() => {
    var _options$applicantId;
    return computeFillOutVisibility(APPLICATION_STEPS.OTHER_PROPERTIES, {
      applicantId: (_options$applicantId = options.applicantId) == null ? void 0 : _options$applicantId.value
    }).value;
  });
  const otherPropertyPurchasePriceVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-details][purchase-price]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyEstimatedValueVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-details][estimated-value]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyPurchaseDateVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-details][purchase-date]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyAddressVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-details][address]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyFeesIncludeHeatVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][fees-include-heat]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyHeatingVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][heating]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-costs][heating]", [otherPropertyPath.value + "[property-costs][fees-include-heat]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyIncludeInTdsVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][include-in-tds]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyMaintenanceFeesVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][maintenance-fees]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyPercOfTotalMaintFeesVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][perc-of-total-maint-fees]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyPropertyTaxesVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-costs][property-taxes]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyHydroVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][hydro]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][hydro]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyInsuranceVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][insurance]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][insurance]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyInterestVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][interest]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][interest]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyManagementVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][management]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][management]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyMonthlyIncomeVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][monthly-income]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][monthly-income]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyOccupancyVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][occupancy]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyOthersVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][others]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][others]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyRentalIncomeOptionsVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][rental-income-options]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][rental-income-options]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyRentalIncomeOptionsPercentVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][rental-income-options-percent]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][rental-income-options-percent]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyRepairsVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(otherPropertyVisibilityPath.value + "[property-rental][repairs]");
    const visibleFromToggler = computeTogglerVisibility(otherPropertyPath.value + "[property-rental][repairs]", [otherPropertyPath.value + "[property-rental][occupancy]"]);
    return visibleFromSchema.value && visibleFromToggler.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageBalanceRemainingVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[balance-remaining]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageFrequencyVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[frequency]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageInterestRateVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[interest-rate]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageLenderVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[lender]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageLoanTypeVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[loan-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageMaturityDateVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[maturity-date]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageMortgageTypeVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[mortgage-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageOrigAmountVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[orig-amount]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgagePaymentAmountVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[payment-amount]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgagePayoffVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[payoff]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageRateTypeVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[rate-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  const otherPropertyExistingMortgageTermTypeVisibility = computed(() => {
    const visibleFromSchema = computeSchemaVisibility(existingMortgageVisibilityPath.value + "[term-type]");
    return visibleFromSchema.value && isApplicantVisibleFromFillOut.value;
  });
  return {
    otherPropertyPurchasePriceVisibility,
    otherPropertyEstimatedValueVisibility,
    otherPropertyPurchaseDateVisibility,
    otherPropertyAddressVisibility,
    otherPropertyFeesIncludeHeatVisibility,
    otherPropertyHeatingVisibility,
    otherPropertyIncludeInTdsVisibility,
    otherPropertyMaintenanceFeesVisibility,
    otherPropertyPercOfTotalMaintFeesVisibility,
    otherPropertyPropertyTaxesVisibility,
    otherPropertyHydroVisibility,
    otherPropertyInsuranceVisibility,
    otherPropertyInterestVisibility,
    otherPropertyManagementVisibility,
    otherPropertyMonthlyIncomeVisibility,
    otherPropertyOccupancyVisibility,
    otherPropertyOthersVisibility,
    otherPropertyRentalIncomeOptionsVisibility,
    otherPropertyRentalIncomeOptionsPercentVisibility,
    otherPropertyRepairsVisibility,
    otherPropertyExistingMortgageBalanceRemainingVisibility,
    otherPropertyExistingMortgageFrequencyVisibility,
    otherPropertyExistingMortgageInterestRateVisibility,
    otherPropertyExistingMortgageLenderVisibility,
    otherPropertyExistingMortgageLoanTypeVisibility,
    otherPropertyExistingMortgageMaturityDateVisibility,
    otherPropertyExistingMortgageMortgageTypeVisibility,
    otherPropertyExistingMortgageOrigAmountVisibility,
    otherPropertyExistingMortgagePaymentAmountVisibility,
    otherPropertyExistingMortgagePayoffVisibility,
    otherPropertyExistingMortgageRateTypeVisibility,
    otherPropertyExistingMortgageTermTypeVisibility
  };
};